import React from "react";
import "./MBSettingsTab.css";

const SETTINGS = [
  ["hazardLayer", "Hazards", "Show the Hazards tab and hazard configuration in the Config tab."],
  ["fetchData", "Fetch data", "Show data fetching tools and their job results."],
];

export default function MBSettingsTab({ permissions, onChange, savingKey, error }) {
  return (
    <section className="mb-settings" aria-labelledby="mb-settings-title">
      <h2 id="mb-settings-title">Settings</h2>
      <p>Choose which Builder features are available</p>
      {SETTINGS.map(([key, label, description]) => (
        <label className="mb-settings-option" key={key}>
          <span><strong>{label}</strong><small>{description}</small></span>
          <input type="checkbox" checked={Boolean(permissions[key])} disabled={Boolean(savingKey)} onChange={(event) => onChange(key, event.target.checked)} />
        </label>
      ))}
      {savingKey && <p className="mb-settings-status" role="status">Saving…</p>}
      {error && <p className="mb-settings-error" role="alert">{error}</p>}
    </section>
  );
}
